<template>
  <div>
    <div v-if="!NavSolid" :class="NavSolid ? ' ' : 'menu-area-body'" style="height: 5rem"></div>
    <div class="bg-light">
      <div class="container-custom">
        <div class="row py-5">
          <div class="col-lg-3 col-md-4 col-12 sticky-div mt-3" :style="isDesktop ? 'height: 95vh; top: 1rem' : ''">
            <!-- <h5 class="d-none d-lg-block mb-3">B?squeda avanzada</h5> -->
            <div class="card shadow p-4   rounded" :class="isDesktop ? '' : (showFilters ? '' : 'd-none')">
              <filterHome :origen="'propiedades'" :data="dataFilterHome" botonTransparent="btn-light-primary" :clase="trasparemt"></filterHome>
            </div>
          </div>
          <div class="col-lg-9 col-md-8 col-12">
            <div class="d-flex flex-column flex-md-row">
              <div data-aos="fade-down">
                <h1 class="h2">{{ seoHeading }}</h1>
                <div class="   ">
                  <p class="text-secondary mb-0">
                    <!-- Mostrar conteo de resultados de la p?gina actual -->
                    {{ $t('properties.showingOf', { shown: items.length, total: totalItems }) }}

                    <!-- {{ this.listaPropiedades }} -->
                  </p>
                  <p class="text-secondary mb-0 ">
                    {{ $t('properties.pageOf', { current: currentPage, total: totalPages }) }}

                    <!-- {{ this.listaPropiedades }} -->
                  </p>
                  <!-- {{ "P?gina: " + currentPage + " de " + totalPages }} <br />
                    ordenarPorPrecio : {{ currentOrderBy === "Precio_de_Venta" ? (currentOrderDir === "ASC" ? "Ascendente" : "Descendente") : "No ordenado por precio" }} <br />
                    ordenarPorFecha : {{ currentOrderBy === "Fecha_Publicada" ? (currentOrderDir === "ASC" ? "Ascendente" : "Descendente") : "No ordenado por fecha" }} -->
                </div>
              </div>

              <div class="btn-toolbar-actions ml-md-auto d-flex align-items-center gap-2 mt-3 mt-md-0">
                <!-- Botones de vista - solo visible en desktop -->
                <div class="btn-group-toggle-group   align-items-center bg-card rounded shadow-sm p-1 d-none d-lg-flex">
                  <button
                    :class="showButton == true ? 'btn-active-primary' : 'btn-inactive'"
                    @click="showButton = true"
                    class="btn-toggle btn btn-sm"
                    :title="$t('properties.gridView')"
                  >
                    <i class="fa-solid fa-grip-vertical"></i>
                  </button>
                  <button
                    :class="showButton != true ? 'btn-active-primary' : 'btn-inactive'"
                    @click="showButton = false"
                    class="btn-toggle btn btn-sm"
                    :title="$t('properties.listView')"
                  >
                    <i class="fa-solid fa-list"></i>
                  </button>
                </div>
                
                <!-- Bot?n de filtro - solo visible en responsive -->
                <button class="btn btn-light-primary mr-auto btn-pill d-lg-none" @click="showFilters = !showFilters">
                  <i class="fas fa-sliders mr-1"></i> {{ $t('common.filter') }}
                </button>
                
                <div class="btn-group-sort d-flex align-items-center bg-card rounded shadow-sm p-1">
                  <button
                    @click="ordenar()"
                    class="btn-sort btn btn-sm d-flex align-items-center justify-content-center"
                    :class="currentOrderBy === 'Fecha_Publicada' ? 'btn-sort-active' : ''"
                    :title="currentOrderBy === 'Fecha_Publicada' ? (currentOrderDir === 'ASC' ? $t('properties.sortByDateDesc') : $t('properties.sortByDateAsc')) : $t('properties.sortByDate')"
                  >
                    <i class="fas fa-calendar-alt mr-1"></i>
                    <i v-if="currentOrderBy === 'Fecha_Publicada'" :class="currentOrderDir === 'ASC' ? 'fas fa-long-arrow-alt-up' : 'fas fa-long-arrow-alt-down'"></i>
                  </button>

                  <button
                    @click="ordenarPorPrecio()"
                    class="btn-sort btn btn-sm d-flex align-items-center justify-content-center"
                    :class="currentOrderBy === priceOrderField ? 'btn-sort-active' : ''"
                    :title="currentOrderBy === priceOrderField ? (currentOrderDir === 'ASC' ? $t('properties.sortByPriceAsc') : $t('properties.sortByPriceDesc')) : $t('properties.sortByPrice')"
                  >
                    <i class="fas fa-dollar-sign mr-1"></i>
                    <i v-if="currentOrderBy === priceOrderField" :class="currentOrderDir === 'ASC' ? 'fas fa-long-arrow-alt-up' : 'fas fa-long-arrow-alt-down'"></i>
                  </button>
                </div>
                

              </div>
            </div>
            <hr />
            <alertComponent
              v-if="items.length == 0 && !loadingData && !initialLoading"
              iconColor="primary"
              :variant="1"
              :icon="true"
              iconClass="fa-solid fa-house-circle-exclamation"
              :title="$t('properties.notFoundTitle')"
              :description="$t('properties.notFoundDesc')"
            ></alertComponent>

            <div class="d-none d-sm-block" v-if="items.length > 0">
              <div v-if="showButton == true" class="row mx-sm-0 product-grid-mobile">
                <!-- Usar items directamente, ya que ahora contiene solo los de la p?gina actual -->
                <div class="col-6" v-for="el in items" :key="el.Id_propiedad">
                  <product-vue :product="el" :auto-slide="false"  />
                </div>
              </div>
              <div v-else class="">
                <div class="row mx-sm-0 product-list-mobile">
                  <!-- Usar items directamente -->
                  <div class="col-12" v-for="el in items" :key="el.Id_propiedad">
                    <ProductPropertiesLarge :product="el" :detail="true" :auto-slide="false" class="bg-card rounded shadow" />
                  </div>
                </div>
              </div>
            </div>
            <div class="d-md-none" v-if="items.length > 0">
              <div class="row mx-sm-0">
                <!-- Usar items directamente -->
                <div class="col-12" v-for="el in items" :key="el.Id_propiedad">
                  <product-vue :product="el" :auto-slide="false" />
                </div>
              </div>
            </div>

            <!-- Paginador -->
            <nav :aria-label="$t('properties.paginationAria')" class="mt-4" v-if="totalPages > 1">
              <ul class="pagination justify-content-center">
                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                  <span v-if="currentPage === 1" class="page-link">{{ $t('common.previous') }}</span>
                  <router-link
                    v-else
                    class="page-link"
                    :to="pageLocation(currentPage - 1)"
                    @click.native="scrollToListingTop"
                  >{{ $t('common.previous') }}</router-link>
                </li>
                <!-- Mostrar una ventana de páginas para evitar desborde móvil -->
                <li
                  v-for="(n, index) in visiblePages"
                  :key="`${n || 'ellipsis'}-${index}`"
                  class="page-item"
                  :class="{ active: currentPage === n, disabled: n === null }"
                >
                  <span v-if="n === null" class="page-link pagination-ellipsis" aria-hidden="true">…</span>
                  <span v-if="currentPage === n" class="page-link" aria-current="page">{{ n }}</span>
                  <router-link
                    v-else-if="n !== null"
                    class="page-link"
                    :to="pageLocation(n)"
                    @click.native="scrollToListingTop"
                  >{{ n }}</router-link>
                </li>
                <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                  <span v-if="currentPage === totalPages" class="page-link">{{ $t('common.next') }}</span>
                  <router-link
                    v-else
                    class="page-link"
                    :to="pageLocation(currentPage + 1)"
                    @click.native="scrollToListingTop"
                  >{{ $t('common.next') }}</router-link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AOS from 'aos'
import alertComponent from "../components/alertComponent.vue";
import filterHome from "../components/filterHome.vue";
import carousel from "../components/carousel.vue";
import ProductVue from "../components/ProductProperties.vue";
import ProductPropertiesLarge from "../components/ProductPropertiesLarge.vue";
import { mapState } from "vuex";
import { eventBus } from "../main";
import { resolveStoredPublicDomain } from "@/utils/publicDomainStorage";
import {
  buildFilterSeoLocation,
  buildFilterSeoRequestPath,
  buildPublicSearchPayload,
  findCatalogItemsBySlugs,
  getFilterRouteSlugs,
} from "@/utils/filterSeoUrl";
import { applySeo, markPrerenderPending, markPrerenderReady } from "@/utils/seo";
import { tField } from "@/i18n";

export default {
  props: ["NavSolid"],
  computed: {
    ...mapState(["listaPropiedades", "dataFilterHome"]),
    priceOrderField() {
      const op = this.$route.params.operation;
      // Acepta el operation en espanol o en ingles (URLs en /en/).
      return (op === "alquiler" || op === "for-rent")
        ? "Precio_de_Alquiler"
        : "Precio_de_Venta";
    },
    visiblePages() {
      const total = Number(this.totalPages) || 0;
      const current = Number(this.currentPage) || 1;

      if (total <= 7) {
        return Array.from({ length: total }, (_, index) => index + 1);
      }

      const pages = [1];
      const start = Math.max(2, current - 1);
      const end = Math.min(total - 1, current + 1);

      if (start > 2) {
        pages.push(null);
      }

      for (let page = start; page <= end; page += 1) {
        pages.push(page);
      }

      if (end < total - 1) {
        pages.push(null);
      }

      pages.push(total);
      return pages;
    },
  },
  components: {
    carousel,
    ProductVue,
    ProductPropertiesLarge,
    filterHome,
    alertComponent,
  },
  data() {
    return {
      trasparemt: 0,
      showFilters: false,
      isDesktop: true,
      showButton: false,
      items: [],
      // ? Estado unificado para el ordenamiento
      currentOrderBy: "Id_Propiedad",
      currentOrderDir: "DESC", // Por defecto: m?s recientes (por ID) primero
      currentPage: 1,
      itemsPerPage: 20,
      totalItems: 0,
      totalPages: 0,
      loadingData: false,
      // FIX bug UX: durante el primer mount de la vista, items=[] y
      // loadingData=false, asi que se mostraba el alert "no encontradas"
      // durante 1-2s hasta que llega la primera respuesta de la API.
      // initialLoading=true mientras esperamos la PRIMERA carga; se pone
      // false en el mounted() despues de que loadCurrentSeoRoute() termina
      // (con o sin resultados). Cargas posteriores (paginacion, filtros)
      // usan loadingData normal, no este flag.
      initialLoading: true,
      row: {},
      seoHeading: "",
      orden: false,
      ordenPrecio: false,

    };
  },
  beforeDestroy() {
    eventBus.$off("filtrando");
    window.removeEventListener('resize', this.checkDesktop);
  },
  watch: {
    "$route.fullPath": async function (newPath, oldPath) {
      // Las rutas filtradas (/es/propiedades/venta/casa/managua) no siempre
      // tienen name en vue-router; detectar por path evita que la paginacion
      // cambie la URL sin recargar datos.
      const isListingRoute = /^\/(?:es\/propiedades|en\/properties)(?:\/|$)/.test(
        this.$route.path
      );
      if (
        newPath !== oldPath &&
        isListingRoute
      ) {
        await this.loadCurrentSeoRoute();
      }
    },
  },
  async mounted() {
    this.checkDesktop();
    window.addEventListener('resize', this.checkDesktop);

    eventBus.$on("filtrando", async (data) => {
      this.currentPage = 1;
      this.items = this.listaPropiedades.properties;
      this.row = this.dataFilterHome;
      this.totalItems = this.listaPropiedades.pagination.totalItems;
      this.totalPages = this.listaPropiedades.pagination.totalPages;
      console.log("props------------->", data);
      await this.applyFilterSeo(this.row);
      window.scrollTo(0, 0);
    });
    // FIX bug UX: mostrar el loader fullscreen (vuejs-loading-screen,
    // mismo que se usa al cargar la app) mientras llega la primera
    // respuesta de la API. Asi el cliente no ve la pagina "rota" durante
    // 1-2s. El loader se muestra via $root.$isLoading (configurado en
    // main.js con el logo del tenant y el fondo azul).
    this.$root.$isLoading(true);
    try {
      await this.loadCurrentSeoRoute();
    } finally {
      this.$root.$isLoading(false);
      this.initialLoading = false;
    }
  },
  updated() {
    AOS.refresh()
  },
  methods: {
    hasStoredResultsForCurrentRoute() {
      if (
        !this.listaPropiedades ||
        !Array.isArray(this.listaPropiedades.properties) ||
        !this.dataFilterHome ||
        Object.keys(this.dataFilterHome).length === 0
      ) {
        return false;
      }

      const storedLocation = buildFilterSeoLocation(this.dataFilterHome, (this.$i18n && this.$i18n.locale) || 'es');
      const storedRoute = this.$router.resolve(storedLocation).route;
      if (storedRoute.fullPath !== this.$route.fullPath) {
        return false;
      }

      // FIX bug paginacion: el cache tambien debe matchear el numero de pagina
      // actual. Sin esto, al volver de pagina 2 a pagina 1 (URL sin ?pagina=N),
      // el cache devuelve los items de la pagina 2 (que es la ultima carga).
      // El backend devuelve pagination.currentPage en la respuesta, lo usamos
      // para validar que el cache corresponde a la misma pagina.
      const currentPage = this.getQueryPage();
      const cachedPage = this.listaPropiedades.pagination?.currentPage;
      return Number(cachedPage) === Number(currentPage);
    },
    useStoredFilterResults() {
      this.currentPage = this.getQueryPage();
      this.items = this.listaPropiedades.properties;
      this.row = this.dataFilterHome;
      this.totalItems = this.listaPropiedades.pagination?.totalItems || 0;
      this.totalPages = this.listaPropiedades.pagination?.totalPages || 0;
    },
    async getPublicCatalog(path, domain) {
      // FIX: NO filtrar por `Id2 == null` aca. El findCatalogItemBySlug
      // necesita buscar en TODOS los items del catalogo (incluyendo los
      // overrides del tenant con Id2 != null) para matchear el slug
      // del URL correctamente. Ej: "Villa Fontana" tiene Id2=6 en el
      // tenant de Pablo Cuadra, pero el URL del usuario lo pide, y
      // si filtramos aca, el slug no matchea, routeCatalogsAreValid
      // falla, y se muestra "Propiedades no encontradas" aunque
      // existan propiedades que matcheen.
      //
      // El filterHome.vue sigue filtrando por Id2 == null para evitar
      // duplicados visuales (item base + override) en los selects.
      // El resolveRouteCatalogs matchea por slug sobre el catalogo
      // completo, y los items resultantes se usan para el v-model
      // del filterHome (que matchea por Id). Si un item del v-model
      // no esta en options (porque el filterHome lo filtro), vue-
      // multiselect lo muestra usando su propio _label.
      const response = await this.$store.dispatch("get", {
        path: `${path}?domain=${encodeURIComponent(domain)}`,
      });
      return Array.isArray(response) ? response : [];
    },
    async resolveRouteCatalogs(domain) {
      const slugs = getFilterRouteSlugs(this.$route);
      const [propertyTypes, cities] = await Promise.all([
        this.getPublicCatalog("Tipo_de_Propiedad/public/getAll", domain),
        this.getPublicCatalog("Ubicacion_Ciudad/public/getAll", domain),
      ]);
      // Multi-value: propertyTypes y cities pueden ser arrays
      // (varios slugs separados por '+' en la URL).
      const propertyTypesResolved = findCatalogItemsBySlugs(
        propertyTypes,
        slugs.propertyType,
        slugs.locale
      );
      const citiesResolved = findCatalogItemsBySlugs(
        cities,
        slugs.city,
        slugs.locale
      );
      // Para zonas, el endpoint Ubicacion_Zona/public/getByFilterHome
      // acepta UN ARRAY de ciudades (multi-ciudad) y devuelve la UNION
      // de todas las zonas que matcheen. Esto es importante cuando el
      // URL tiene multi-ciudad + multi-zona (ej: leon+rivas/poneloya+
      // san-juan-del-sur+tola), donde las zonas son de DIFERENTES
      // ciudades. ANTES este codigo solo usaba la primera ciudad
      // (citiesResolved[0]) y las zonas de las otras ciudades se
      // perdian, rompiendo el match del slug y mostrando "Propiedades
      // no encontradas" aunque hubieran resultados.
      // FIX: enviar `citiesResolved` (array completo) al endpoint.
      // FIX: NO filtrar por Id2 == null aca tampoco. El findCatalogItemBySlug
      // necesita TODOS los items (incluyendo overrides del tenant con
      // Id2 != null) para matchear el slug del URL.
      let zones = [];
      if (citiesResolved.length && slugs.zone.length) {
        const response = await this.$store.dispatch("post", {
          path: `Ubicacion_Zona/public/getByFilterHome?domain=${encodeURIComponent(
            domain
          )}`,
          data: {
            Domain: domain,
            selectedCity: citiesResolved,
          },
        });
        zones = Array.isArray(response) ? response : [];
      }
      const zonesResolved = findCatalogItemsBySlugs(
        zones,
        slugs.zone,
        slugs.locale
      );

      return {
        slugs,
        propertyTypes: propertyTypesResolved,
        cities: citiesResolved,
        zones: zonesResolved,
      };
    },
    routeCatalogsAreValid(resolved) {
      const { slugs, propertyTypes, cities, zones } = resolved;
      // Acepta el operation en espanol (default) o en ingles (URLs en /en/).
      const validOps = ['venta', 'alquiler', 'for-sale', 'for-rent'];
      // Si hay slugs en algun campo, TODOS deben matchear con items
      // del catalogo (si alguno no matchea, la URL es invalida).
      const propertyTypesValid =
        !slugs.propertyType.length || propertyTypes.length === slugs.propertyType.length;
      const citiesValid =
        !slugs.city.length || cities.length === slugs.city.length;
      const zonesValid =
        !slugs.zone.length || zones.length === slugs.zone.length;
      return (
        propertyTypesValid &&
        citiesValid &&
        zonesValid &&
        (!slugs.operation || validOps.includes(slugs.operation))
      );
    },
    buildRowFromSeo(seo, resolved) {
      const searchBody = seo?.searchBody || {};
      const bedroom = searchBody.selectedBedrooms?.[0]?.Id ?? null;
      const bathroom = searchBody.selectedBathrooms?.[0]?.Id ?? null;
      // El filterHome.vue usa multiselects con `label="_label"` para
      // resolver el texto del tag segun el locale activo. Los items
      // que vienen del catalogo original (resolved.propertyTypes,
      // resolved.cities, resolved.zones) NO tienen ese campo; hay
      // que agregarlo aca para que los tags rendericen con el
      // nombre correcto (ej. "Casa" en ES, "House" en EN).
      const locale = (this.$i18n && this.$i18n.locale) || 'es';
      const withLabel = (items) => (Array.isArray(items) ? items : []).map((x) => ({
        ...x,
        _label: tField(x, 'Nombre', locale),
      }));

      return {
        ...searchBody,
        // Multi-value: propertyTypes/cities/zones son arrays
        // (varios items). El filterHome.vue usa estos arrays para
        // mostrar los tags como en la captura.
        TypePropertySelected: withLabel(resolved.propertyTypes),
        selectedCity: withLabel(resolved.cities),
        selectedZone: withLabel(resolved.zones),
        selectedZones: withLabel(resolved.zones),
        bedCount: bedroom,
        bathCount: bathroom,
        priceRange:
          searchBody.priceRange ||
          (searchBody.isAlquiler ? [0, 10000] : [0, 1000000]),
        areaRange: searchBody.areaRange || [0, 1000],
        lotSizeRange: searchBody.lotSizeRange || [0, 10000],
      };
    },
    async fetchFilterSeo(row, resolvedCatalogs = null) {
      const domain = resolveStoredPublicDomain(this.$domain);
      // Multi-value: pasar arrays completos. El builder los serializa
      // como typeId=1&typeId=2 (multi-param) o typeId=1,2 (CSV).
      const resolved =
        resolvedCatalogs || {
          propertyTypes: row?.TypePropertySelected || [],
          cities: row?.selectedCity || [],
          zones: row?.selectedZone && row.selectedZone.length
            ? row.selectedZone
            : (row?.selectedZones || []),
        };
      const path = buildFilterSeoRequestPath({
        domain,
        route: this.$route,
        propertyTypes: resolved.propertyTypes,
        cities: resolved.cities,
        zones: resolved.zones,
      });
      const seo = await this.$store.dispatch("get", { path });

      if (!seo || !seo.canonical) {
        throw new Error("No fue posible obtener los metadatos del listado");
      }

      return seo;
    },
    async applyFilterSeo(row) {
      try {
        const seo = await this.fetchFilterSeo(row);
        // FIX: el backend YA devuelve los meta tags completos y correctos
        // (h1, title con el nombre real del tenant, description con el
        // count real de propiedades, etc). NO sobrescribimos nada.
        // El comentario anterior era incorrecto: pasaba el seo por
        // localizeSeoText() con fallbacks GENERICOS (properties.defaultHeading
        // = "Listado de propiedades", home.latestForRent = "Lo ultimo en
        // alquiler") y concatenaba ' | Pablo Cuadra' HARDCODED al titulo
        // (otros tenants veian "Pablo Cuadra" en su titulo, incorrecto).
        this.seoHeading = seo.h1;
        applySeo(seo);
      } catch (error) {
        console.error("Error al aplicar SEO del listado:", error);
        markPrerenderReady();
      }
    },
    applyListingQueryState() {
      const order = this.getQueryOrder();
      const priceField = this.priceOrderField;
      const orderMap = {
        "price-asc": [priceField, "ASC"],
        "price-desc": [priceField, "DESC"],
        "date-asc": ["Fecha_Publicada", "ASC"],
        "date-desc": ["Fecha_Publicada", "DESC"],
      };
      const selectedOrder = orderMap[order];

      if (selectedOrder) {
        [this.currentOrderBy, this.currentOrderDir] = selectedOrder;
      } else {
        this.currentOrderBy = "Id_Propiedad";
        this.currentOrderDir = "DESC";
      }
    },
    async updateListingQuery(changes = {}) {
      const query = { ...this.$route.query, ...changes };
      Object.keys(query).forEach((key) => {
        if (query[key] === undefined || query[key] === null || query[key] === "") {
          delete query[key];
        }
      });

      const target = {
        path: this.$route.path,
        query,
      };
      const targetRoute = this.$router.resolve(target).route.fullPath;
      if (targetRoute === this.$route.fullPath) {
        return;
      }

      await this.$router.push(target);
    },
    getQueryPage() {
      return Number(this.$route.query.pagina ?? this.$route.query.page) || 1;
    },
    getQueryOrder() {
      return String(this.$route.query.orden ?? this.$route.query.order ?? "");
    },
    async normalizeLegacyListingQuery() {
      const query = { ...this.$route.query };
      let changed = false;

      if (query.pagina === undefined && query.page !== undefined) {
        query.pagina = query.page;
        changed = true;
      }
      if (query.orden === undefined && query.order !== undefined) {
        query.orden = query.order;
        changed = true;
      }
      if (!changed) {
        return false;
      }

      delete query.page;
      delete query.order;
      try {
        await this.$router.replace({ path: this.$route.path, query });
      } catch (error) {
        // NavigationDuplicated es esperable cuando el path+query resuelven
        // a la misma URL actual (vue-router 3.x). No es un error real.
        if (error?.name !== 'NavigationDuplicated') {
          throw error;
        }
      }
      return true;
    },
    async normalizeListingPath(row) {
      // Ya no modificamos la URL del listing desde aqui. La URL se mantiene
      // como esta (ej /en/properties o /es/propiedades) y el applySeo
      // se encarga de actualizar <title>, <meta canonical>, <meta hreflang>
      // y el SEO JSON segun el locale activo. El usuario puede cambiar el
      // locale desde el LanguageSelector (que hace full reload con la
      // URL correctamente localizada).
      //
      // Antes este metodo llamaba a router.replace con paths legacy
      // (/propiedades) y provocaba redirects que rompen la pagina
      // (/en/properties -> /es/propiedades -> /). Se deja el esqueleto
      // para que el watch "$route.fullPath" no rompa al invocarlo.
      const _ = row;
      return false;
    },
    pageLocation(page) {
      const query = { ...this.$route.query };
      delete query.page;
      delete query.order;
      if (page > 1) {
        query.pagina = String(page);
      } else {
        delete query.pagina;
      }
      return { path: this.$route.path, query };
    },
    scrollToListingTop() {
      window.scrollTo(0, 0);
    },
    async loadCurrentSeoRoute() {
      if (await this.normalizeLegacyListingQuery()) {
        return;
      }
      markPrerenderPending();
      this.currentPage = this.getQueryPage();
      this.applyListingQueryState();

      try {
        if (this.hasStoredResultsForCurrentRoute()) {
          this.useStoredFilterResults();
          await this.applyFilterSeo(this.row);
          return;
        }

        const domain = resolveStoredPublicDomain(this.$domain);
        const resolved = await this.resolveRouteCatalogs(domain);
        if (!this.routeCatalogsAreValid(resolved)) {
          this.items = [];
          this.totalItems = 0;
          this.totalPages = 0;
          this.seoHeading = this.$t('properties.noResultsTitle');
          applySeo({
            title: this.$t('properties.noResultsTitle'),
            description: this.$t('properties.noResultsDesc'),
            canonical: window.location.href,
            robots: "noindex, follow",
          });
          return;
        }

        const seo = await this.fetchFilterSeo(null, resolved);
        this.row = this.buildRowFromSeo(seo, resolved);
        if (await this.normalizeListingPath(this.row)) {
          return;
        }
        this.$store.commit("setdataFilterHome", this.row);
        // FIX: el backend YA devuelve los meta tags completos y correctos.
        // NO sobrescribimos nada (antes sobrescribiamos con fallbacks
        // genericos tipo "Listado de propiedades" + " | Pablo Cuadra"
        // hardcoded + "Lo ultimo en alquiler").
        this.seoHeading = seo.h1;
        applySeo(seo);
        await this.getDataFilter();
      } catch (error) {
        console.error("Error al cargar la ruta SEO del listado:", error);
        this.items = [];
        this.totalItems = 0;
        this.totalPages = 0;
        markPrerenderReady();
      }
    },
    checkDesktop() {
      this.isDesktop = window.innerWidth >= 992;
      if (this.isDesktop) this.showFilters = true;
    },
    // Devuelve el texto SEO localizado segun el locale activo. Si el API
    // devuelve texto en espanol (que es lo que hace hoy), usamos el i18n
    // para traducir. Si en el futuro el API soporta locale, este helper
    // ya esta preparado para devolver ese valor directamente.
    async getDataByOrigin() {
      if (this.$route.name === "PropertiesListing" && Object.keys(this.row).length) {
        await this.getDataFilter();
      } else {
        await this.getData();
      }
    },
    async ordenarPorPrecio() {
      const priceField = this.priceOrderField;
      if (this.currentOrderBy === priceField) {
        this.currentOrderDir = this.currentOrderDir === "ASC" ? "DESC" : "ASC";
      } else {
        this.currentOrderBy = priceField;
        this.currentOrderDir = "DESC"; // Mayor precio primero
      }
      this.currentPage = 1;
      await this.updateListingQuery({
        orden: this.currentOrderDir === "ASC" ? "price-asc" : "price-desc",
        pagina: undefined,
      });
    },
    async ordenar() {
      // Si ya est? ordenado por fecha, invertir la direcci?n
      if (this.currentOrderBy === "Fecha_Publicada") {
        this.currentOrderDir = this.currentOrderDir === "ASC" ? "DESC" : "ASC";
      } else {
        // Primera vez: ordenar por fecha, m?s reciente primero (DESC)
        this.currentOrderBy = "Fecha_Publicada";
        this.currentOrderDir = "DESC";
      }
      this.currentPage = 1;
      await this.updateListingQuery({
        orden: this.currentOrderDir === "ASC" ? "date-asc" : "date-desc",
        pagina: undefined,
      });
    },
    async getDataFilter() {
      try {
        this.loadingData = true;
        this.$root.$isLoading(true);

        const domain = resolveStoredPublicDomain(this.$domain);
        const url = `Propiedades/public/searchFromFilterHome?page=${this.currentPage}&limit=${this.itemsPerPage}&orderBy=${this.currentOrderBy}&orderDir=${this.currentOrderDir}&domain=${encodeURIComponent(domain)}`;
        const payload = buildPublicSearchPayload(this.row, domain);
        const res = await this.$store.dispatch("post", {
          path: url,
          data: payload,
        });

        // const res = await this.$store.dispatch("get", { path: url });

        if (res && res.properties) {
          this.items = res.properties;
          this.totalItems = res.pagination.totalItems;
          this.totalPages = res.pagination.totalPages;
          this.$store.commit("setListaPropiedades", res);
          this.$store.commit("setdataFilterHome", this.row);
        } else {
          this.items = [];
          this.totalItems = 0;
          this.totalPages = 0;
        }
      } catch (error) {
        console.error("Error al cargar datos:", error);
        this.items = [];
        this.totalItems = 0;
        this.totalPages = 0;
      } finally {
        this.$root.$isLoading(false);
        this.loadingData = false;
      }
    },
    async getData() {
      try {
        this.loadingData = true;
        this.$root.$isLoading(true);

        const tipo = "3"; // Ajusta según tu lógica si necesitas cambiar este valor
        const domain = encodeURIComponent(resolveStoredPublicDomain(this.$domain));

        // ✅ Usar el estado actual del componente
        const url = `Propiedades/public/getLastByType/${tipo}?page=${this.currentPage}&limit=${this.itemsPerPage}&orderBy=${this.currentOrderBy}&orderDir=${this.currentOrderDir}&domain=${domain}`;

        const res = await this.$store.dispatch("get", { path: url });

        if (res && res.data) {
          this.items = res.data;
          this.totalItems = res.pagination.totalItems;
          this.totalPages = res.pagination.totalPages;
        } else {
          this.items = [];
          this.totalItems = 0;
          this.totalPages = 0;
        }
      } catch (error) {
        console.error("Error al cargar datos:", error);
        this.items = [];
        this.totalItems = 0;
        this.totalPages = 0;
      } finally {
        this.$root.$isLoading(false);
        this.loadingData = false;
      }
    },
    async goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        await this.updateListingQuery({
          pagina: page > 1 ? String(page) : undefined,
        });
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>

<style scoped>
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fdfcfc;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #e9e9e9;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #e9e9e9;
}
.inner {
  max-width: 100%;
  margin: auto;
  padding-left: 15px;
  padding-right: 15px;
}
.scroll-container {
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;

  scroll-snap-type: mandatory;
  scroll-behavior: smooth;

  word-wrap: break-word !important;
  margin-bottom: 50px;
}

.scroll-container .scroll-section {
  display: inline-block;
  vertical-align: middle;

  /* white-space: nowrap; */
}
/*Slider X (different sized images)*/

.scroll-container.diff-size {
  scroll-snap-destination: 50% 0%;
  padding: 20px 0px;
  margin: 1%;
}

.scroll-container.diff-size .scroll-section {
  width: auto;
  height: 100%;
  margin-right: 15px;
  scroll-snap-coordinate: 50% 0%;
}

.scroll-container.diff-size .scroll-section:first-child {
  scroll-snap-coordinate: 0% 0%, 50% 0%;
  margin-left: 15px;
}

.scroll-container.diff-size .scroll-section:last-child {
  scroll-snap-coordinate: 50% 0%, 100% 0%;
}

.searchdiv {
  /* background-color:#fd306e !important; */
  /* background-color: black !important; */
  /* padding: 30px;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.25);
  border-radius: 20px; */
}
.buttonsearch {
  background-color: #fd306e !important;
  color: white;
}
.inputSearch {
  border-color: #fd306e !important;
}

@media (max-width: 991px) {
  .sticky-div {
    position: relative !important;
    height: auto !important;
    max-height: none !important;
  }
}

@media (max-width: 576px) {
  .sticky-div {
    margin-bottom: 1rem;
  }
}

@media (max-width: 767px) {
  .btn-toolbar-actions {
    flex-wrap: nowrap;
    gap: 0.4rem !important;
    margin-top: 1rem;
    width: 100%;
    justify-content: flex-end;
  }
  
  .btn-toggle, .btn-sort {
    padding: 0.4rem 0.6rem;
    font-size: 0.875rem;
    min-width: 36px;
    min-height: 36px;
  }
  
  .btn-group-toggle-group, .btn-group-sort {
    gap: 0.25rem;
  }
  
  .btn-toolbar-actions > div {
    flex-shrink: 0;
  }
  
  .btn-filter-mobile {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 8px;
    padding: 0.4rem 0.7rem;
    font-size: 0.8rem;
    font-weight: 600;
    color: #fff;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
  }
  
  .btn-filter-mobile:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.5);
  }
}

@media (max-width: 576px) {
  .pagination {
    flex-wrap: wrap;
    row-gap: 0.35rem;
  }

  .btn-toolbar-actions {
    gap: 0.3rem !important;
  }
  
  .btn-toggle, .btn-sort {
    padding: 0.35rem 0.5rem;
    font-size: 0.8rem;
    min-width: 32px;
    min-height: 32px;
  }
  
  .btn-filter-mobile {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 6px;
    padding: 0.35rem 0.6rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: #fff;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
  }
  
  .product-grid-mobile .col-6,
  .product-grid-mobile .col-12 {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  
  .product-list-mobile .col-12 {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
}

.carousel-item img {
  /* height:100vh!important ; */
}
</style>
